query LpNextSeason {
  lpNextSeason {
    id
    activeSettings {
      activeStart
      activeEnd
    }
    propsContent {
      type
      props
    }
  }
}
